import React from 'react';

export const Recycle = (props: { className?: string }) => {
    return (
        <svg
            width='20'
            height='21'
            viewBox='0 0 20 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={props.className}>
            <path
                d='M4.99586 17H2.81086C2.49543 17.0009 2.18512 16.9203 1.91003 16.7659C1.63495 16.6116 1.40444 16.3887 1.24086 16.119C1.08377 15.8481 1.00071 15.5407 1 15.2275C0.999302 14.9144 1.08099 14.6066 1.23686 14.335L5.19186 7.5M5.19186 7.5L6.28886 11.596M5.19186 7.5L1.09586 8.598M8.99586 17H17.1989C17.5128 16.9976 17.8208 16.9144 18.0933 16.7586C18.3658 16.6027 18.5936 16.3794 18.7549 16.11C18.9098 15.8399 18.9913 15.5339 18.9913 15.2225C18.9913 14.9111 18.9098 14.6051 18.7549 14.335L17.5289 12.215M8.99586 17L11.9959 14M8.99586 17L11.9959 20M7.33986 3.811L8.43286 1.919C8.58981 1.6454 8.81481 1.41701 9.08604 1.25599C9.35727 1.09497 9.66551 1.00679 9.98086 1C10.2938 0.99942 10.6014 1.08116 10.8727 1.23703C11.1441 1.39289 11.3697 1.6174 11.5269 1.888L15.4699 8.731M15.4699 8.731L11.3739 7.633M15.4699 8.731L16.5669 4.635'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default Recycle;
